module.exports = __webpack_public_path__ + "img/84.e9c4bbdc.jpg";